export const REDUCE_BROKERCOMPANY_SIGNUP_ELEMENT = 'REDUCE_BROKERCOMPANY_SIGNUP_ELEMENT';
export const CLEAR_BROKERCOMPANY_SIGNUP = 'CLEAR_BROKERCOMPANY_SIGNUP';
export const UPSERT_BROKERCOMPANY_SIGNUP = 'UPSERT_BROKERCOMPANY_SIGNUP';